const backendHost = process.env.API_HOST;
export const generateImageUrl = (id: string, subdomain: string) => {
  const url = new URL(backendHost as string);
  url.pathname = `api/v1/images/${id}`;
  url.hostname = `${subdomain}.${url.hostname}`;
  return url.toString();
};

export const generatePublicImageUrl = (id: string, subdomain: string, version?: string) => {
  const baseUrl = `/api/images/${subdomain}/${id}`;
  return version ? `${baseUrl}?v=${version}` : baseUrl;
};
